import {
  ActionSheet,
  Button,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  CountDown,
  Dialog,
  Divider,
  Field,
  Form,
  Icon,
  Image as VanImage,
  List,
  Loading,
  Notify,
  Overlay,
  Picker,
  Popup,
  Radio,
  RadioGroup,
  Swipe,
  SwipeItem,
  Tab,
  Tabbar,
  TabbarItem,
  Uploader,
  Tabs,
  Tag,
  Toast,
  Search,
  DatetimePicker,
  Cascader,
  PasswordInput,
  NumberKeyboard
} from 'vant'
import Vue from 'vue'




Toast.allowMultiple()
Vue.use(ActionSheet)
  .use(Search)
  .use(PasswordInput)
  .use(NumberKeyboard)
  .use(Button)
  .use(Uploader)
  .use(CellGroup)
  .use(Cell)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Dialog)
  .use(Field)
  .use(Form)
  .use(Icon)
  .use(List)
  .use(Loading)
  .use(Notify)
  .use(Popup)
  .use(Picker)
  .use(RadioGroup)
  .use(Radio)
  .use(Swipe)
  .use(SwipeItem)
  .use(Toast)
  .use(VanImage)
  .use(Divider)
  .use(Overlay)
  .use(Collapse)
  .use(CollapseItem)
  .use(Tag)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Tab)
  .use(Tabs)
  .use(CountDown)
  .use(DatetimePicker)
  .use(Cascader)
